export const searchedInviteHeroesSelector = state => state.inviteMembers.get('searchedHeroes');
export const searchedInviteHeroesSelectorIsLoading = state => state.inviteMembers.get('isLoading');
export const searchedInviteHeroesHasMoreSelector = state => state.inviteMembers.get('hasMore');
export const searchedInviteHeroesHasMoreSelectorIsLoading = state => state.inviteMembers.get('loadMoreIsLoading');
export const inviteFormSelector = state => state.inviteMembers.get('isSubmitted');
